<template>
  <cost-prices-additional-fee-detail
    ref="costPricesAdditionalFeeDetail"
    type="new"
    :submitting="submitting"
    @submit="submit"
  />
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CostPricesAdditionalFeeDetail from './CostPricesAdditionalFeeDetail.vue';

export default {
  components: {
    CostPricesAdditionalFeeDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      const id = data.providerId;
      this.submitting = true;

      useService
        .createProviderFee(id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'cost-prices-additional-fees' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
